

import React from 'react';
import { CONFIG } from 'config/config';
import RoundedProgressBar from 'components/ProgressBar/RoundedProgressBar/RoundedProgressBar';
import TextProgressBar from 'components/ProgressBar/TextProgressBar/TextProgressBar';

import Text2StepsProgressBar from '../Text2StepsProgressBar/Text2StepsProgressBar';

export const ProgressBar = ({ step }) => {
	return CONFIG.components.progressBar.variant ? (
		CONFIG.components.progressBar.variant === 'text' ? (
			<TextProgressBar step={step} />
		) : CONFIG.components.progressBar.variant === 'text2Steps' ? (
			<Text2StepsProgressBar step={step} steps={CONFIG.components.progressBar.steps} />
		) : CONFIG.components.progressBar.variant === 'roundedWithLabel' ? (
			<RoundedProgressBar showLabel={true} step={step} styleWrapper={{ maxWidth: 450 }} />
		) : CONFIG.components.progressBar.variant === 'roundedWithoutLabel' ? (
			<RoundedProgressBar showLabel={false} step={step} styleWrapper={{ maxWidth: 450 }} />
		) : null
	) : null;
};
